import React, { forwardRef, PureComponent } from 'react';

const SearchIcon = forwardRef((props, ref) => {
  const { color, ...otherProps } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={13}
      height={14}
      viewBox="0 0 13 14"
      fill="none"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.44724 2.448C2.33953 1.55448 3.53996 1.03632 4.80219 0.999865C6.06443 0.963408 7.29274 1.41141 8.23511 2.25195C9.17749 3.09248 9.76247 4.26181 9.86997 5.51999C9.97748 6.77816 9.59935 8.02978 8.81324 9.018L11.8352 12.041C11.9413 12.1464 12.0012 12.2897 12.0017 12.4392C12.0021 12.5888 11.9432 12.7324 11.8377 12.8385C11.7323 12.9446 11.5891 13.0045 11.4395 13.0049C11.29 13.0054 11.1463 12.9464 11.0403 12.841L8.01826 9.818C7.02993 10.6022 5.77915 10.9788 4.52216 10.8706C3.26518 10.7624 2.09712 10.1777 1.25727 9.23626C0.417423 8.29479 -0.030615 7.06782 0.00488946 5.80669C0.0403939 4.54556 0.556764 3.34573 1.44825 2.453L1.44724 2.448ZM4.94724 2.125C4.06393 2.12513 3.20801 2.43152 2.52528 2.99197C1.84254 3.55243 1.37525 4.33227 1.20304 5.19863C1.03083 6.06499 1.16433 6.96426 1.58082 7.74321C1.9973 8.52217 2.67102 9.13262 3.48713 9.47055C4.30324 9.80848 5.21125 9.85298 6.05649 9.59647C6.90174 9.33997 7.63191 8.79832 8.12257 8.06382C8.61322 7.32933 8.83402 6.44742 8.74735 5.56838C8.66068 4.68933 8.27191 3.86753 7.64725 3.243C7.29216 2.88805 6.87054 2.60661 6.40656 2.41477C5.94258 2.22293 5.44532 2.12446 4.94324 2.125H4.94724Z"
        fill={color}
      />
    </svg>
  );
});

SearchIcon.defaultProps = {
  color: '#172B4D',
};

export default SearchIcon;
